import { FC } from 'react'

export const Footer: FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="container text-monochrome-1">
      <div className="flex flex-col py-5 md:flex-row justify-between items-center gap-2 text-sm border-t border-monochrome-120">
        <p>© {currentYear} RHUNA. All Rights Reserved</p>
        <div className="flex gap-4">
          <a href="#" className="hover:text-white transition-colors">
            info@rhuna.com
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
